// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 100%;
  color: var(--ca-text-primary, #172033);
}

.configure-data-asset-page {
  max-width: 1440px;
  margin: 0 auto;
}

.configure-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.eyebrow {
  margin: 0 0 0.35rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.page-title {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2.2vw, 1.75rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}

.page-subtitle {
  max-width: 760px;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
}

.back-button {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.loading-container {
  gap: 0.25rem;
  color: var(--ca-text-secondary, #4b5870);
}

.page-alert {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
}

.page-alert .alert-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.15rem;
}

.page-alert > span {
  flex: 1;
}

.asset-summary-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.15rem;
  padding: 1.15rem 1.25rem;
  background: var(--ca-surface, #fff);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.summary-leading-icon {
  display: inline-flex;
  flex: 0 0 46px;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  color: var(--ca-primary, #0e2e80);
  background: #edf3ff;
  border-radius: 11px;
  font-size: 1.25rem;
}

.summary-main {
  min-width: 0;
  flex: 1;
}

.summary-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.summary-title-row h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.summary-main > p {
  margin: 0.35rem 0 0.7rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.83rem;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.6rem;
  color: #7b5700;
  background: #fff7e6;
  border: 1px solid #f3d79b;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

.status-pill.status-configured {
  color: #176843;
  background: #eaf7f0;
  border-color: #b7e3ca;
}

.status-dot {
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 50%;
}

.summary-metadata {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem 1.2rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  overflow-wrap: anywhere;
}

.summary-metadata span {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.summary-metadata strong {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 600;
}

.configuration-card,
.create-option-card {
  padding: 1.35rem 1.4rem;
  background: var(--ca-surface, #fff);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.section-heading,
.create-option-header {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin-bottom: 1.3rem;
}

.section-heading-icon {
  display: inline-flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: var(--ca-primary, #0e2e80);
  background: #edf3ff;
  border-radius: 10px;
  font-size: 1.05rem;
}

.section-heading h2,
.create-option-header h2 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 700;
}

.section-heading p,
.create-option-header p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.79rem;
}

.optional-note {
  margin-left: auto;
  padding: 0.32rem 0.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  background: var(--ca-bg-secondary, #eef2f8);
  border-radius: 5px;
  font-size: 0.63rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  white-space: nowrap;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.2rem 1.35rem;
}

.field-group {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
}

.field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.field-label-row .form-label {
  margin-bottom: 0;
}

.form-label {
  color: var(--ca-text-primary, #172033);
  font-size: 0.81rem;
  font-weight: 600;
}

.form-control,
.form-select {
  width: 100%;
  min-height: 42px;
  padding: 0.62rem 0.75rem;
  background-color: var(--ca-input-bg, #fff);
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
}

.form-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.71rem;
}

.select-with-status {
  position: relative;
}

.select-with-status .form-select {
  padding-right: 2.4rem;
}

.field-spinner {
  position: absolute;
  top: 50%;
  right: 2rem;
  color: var(--ca-primary, #0e2e80);
  transform: translateY(-50%);
  pointer-events: none;
}

.add-option-button,
.text-action {
  padding: 0;
  border: 0;
  color: var(--ca-primary, #0e2e80);
  background: transparent;
  font-size: 0.72rem;
  font-weight: 600;
}

.add-option-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
}

.add-option-button:hover,
.text-action:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}

.field-error {
  color: #b42332;
  font-size: 0.72rem;
  line-height: 1.4;
}

.create-option-card {
  margin-top: 1rem;
  border-color: #cbd8f4;
  background: #fbfcff;
}

.create-option-header {
  align-items: center;
  margin-bottom: 0.9rem;
}

.small-icon {
  flex-basis: 32px;
  width: 32px;
  height: 32px;
  font-size: 0.9rem;
}

.icon-close-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: auto;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 7px;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
}

.create-option-controls {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
}

.create-option-submit {
  flex-shrink: 0;
  min-height: 42px;
}

.create-option-error {
  display: block;
  margin: 0.65rem 0 0;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding: 1rem 0 0.5rem;
}

.action-note {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.74rem;
}

.action-note i {
  color: var(--ca-primary, #0e2e80);
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.65rem;
}

.action-buttons .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.save-button {
  min-width: 185px;
}

@media (max-width: 767.98px) {
  .configure-page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .back-button {
    align-self: flex-start;
  }
  .asset-summary-card,
  .configuration-card,
  .create-option-card {
    padding: 1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .optional-note {
    display: none;
  }
  .form-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .action-buttons {
    width: 100%;
  }
  .action-buttons .btn {
    flex: 1;
  }
}
@media (max-width: 480px) {
  .asset-summary-card {
    gap: 0.65rem;
    padding: 0.85rem;
  }
  .summary-leading-icon {
    flex-basis: 38px;
    width: 38px;
    height: 38px;
  }
  .summary-metadata {
    flex-direction: column;
    gap: 0.4rem;
  }
  .create-option-controls {
    align-items: stretch;
    flex-direction: column;
  }
  .create-option-submit {
    width: 100%;
  }
  .save-button {
    min-width: 0;
  }
}
/* Breadcrumb used by the shared workflow navigation template. */
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  margin: 1.5rem 0 1rem 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  cursor: pointer;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}

.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}

.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i,
.breadcrumb-current i {
  font-size: 1.25rem;
}

.breadcrumb-divider,
.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

/* Checkbox-based multi-select fields. */
.multi-select-options {
  display: flex;
  min-height: 42px;
  max-height: 210px;
  flex-direction: column;
  gap: 0.1rem;
  overflow-y: auto;
  padding: 0.35rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-input-bg, #fff);
}

.multi-select-options:focus-within {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);
}

.multi-select-option {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin: 0;
  padding: 0.52rem 0.6rem;
  border-radius: 5px;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 400;
  line-height: 1.35;
  cursor: pointer;
}

.multi-select-option:hover {
  background: var(--ca-surface-hover, #f5f8ff);
}

.multi-select-option .form-check-input {
  flex: 0 0 auto;
  margin-top: 0.12rem;
  cursor: pointer;
}

.multi-select-option .form-check-input:checked {
  background-color: var(--ca-primary, #0e2e80);
  border-color: var(--ca-primary, #0e2e80);
}

.multi-select-option span {
  overflow-wrap: anywhere;
}

.multi-select-empty,
.multi-select-loading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.multi-select-loading .spinner-border {
  color: var(--ca-primary, #0e2e80);
}

@media (max-width: 480px) {
  .breadcrumb {
    margin-left: 0.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-configuraion/configure-data-asset-by-id/configure-data-asset-by-id.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,sCAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,wCAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,iDAAA;EACA,wCAAA;EACA,gEAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,OAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,uBAAA;EACA,mCAAA;EACA,iDAAA;EACA,wCAAA;EACA,gEAAA;AACF;;AAEA;;EAEE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,uBAAA;EACA,uCAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,sCAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;;EAEE,4CAAA;EACA,gDAAA;AACF;;AAEA;EACE,oCAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iCAAA;EACA,2BAAA;EACA,oBAAA;AACF;;AAEA;;EAEE,UAAA;EACA,SAAA;EACA,iCAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,sCAAA;EACA,0BAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,sBAAA;IACA,oBAAA;EACF;EAEA;IACE,sBAAA;EAAF;EAGA;;;IAGE,aAAA;EADF;EAIA;IACE,0BAAA;IACA,SAAA;EAFF;EAKA;IACE,aAAA;EAHF;EAMA;IACE,oBAAA;IACA,sBAAA;EAJF;EAOA;IACE,WAAA;EALF;EAQA;IACE,OAAA;EANF;AACF;AASA;EACE;IACE,YAAA;IACA,gBAAA;EAPF;EAUA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;EARF;EAWA;IACE,sBAAA;IACA,WAAA;EATF;EAYA;IACE,oBAAA;IACA,sBAAA;EAVF;EAaA;IACE,WAAA;EAXF;EAcA;IACE,YAAA;EAZF;AACF;AAgBA,gEAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,uCAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAdF;;AAiBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,sCAAA;EACA,0BAAA;AAdF;;AAiBA;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAdF;;AAiBA;;EAEE,kBAAA;AAdF;;AAiBA;;EAEE,oCAAA;AAdF;;AAiBA;EACE,wCAAA;EACA,gBAAA;AAdF;;AAiBA,wCAAA;AACA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,uCAAA;EACA,oCAAA;AAdF;;AAiBA;EACE,4CAAA;EACA,gDAAA;AAdF;;AAiBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,4CAAA;AAdF;;AAiBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,4CAAA;EACA,wCAAA;AAdF;;AAiBA;EACE,uBAAA;AAdF;;AAiBA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,iCAAA;AAdF;;AAiBA;EACE;IACE,mBAAA;EAdF;AACF","sourcesContent":[":host {\n  display: block;\n  min-height: 100%;\n  color: var(--ca-text-primary, #172033);\n}\n\n.configure-data-asset-page {\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n.configure-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n.eyebrow {\n  margin: 0 0 0.35rem;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.11em;\n}\n\n.page-title {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2.2vw, 1.75rem);\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n\n.page-subtitle {\n  max-width: 760px;\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.875rem;\n}\n\n.back-button {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.loading-container {\n  gap: 0.25rem;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.page-alert {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin: 0 0 1rem;\n  padding: 0.85rem 1rem;\n}\n\n.page-alert .alert-copy {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.page-alert > span {\n  flex: 1;\n}\n\n.asset-summary-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.15rem;\n  padding: 1.15rem 1.25rem;\n  background: var(--ca-surface, #fff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.summary-leading-icon {\n  display: inline-flex;\n  flex: 0 0 46px;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  color: var(--ca-primary, #0e2e80);\n  background: #edf3ff;\n  border-radius: 11px;\n  font-size: 1.25rem;\n}\n\n.summary-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.summary-title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.summary-title-row h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.05rem;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.summary-main > p {\n  margin: 0.35rem 0 0.7rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.83rem;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.25rem 0.6rem;\n  color: #7b5700;\n  background: #fff7e6;\n  border: 1px solid #f3d79b;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.status-pill.status-configured {\n  color: #176843;\n  background: #eaf7f0;\n  border-color: #b7e3ca;\n}\n\n.status-dot {\n  width: 6px;\n  height: 6px;\n  background: currentColor;\n  border-radius: 50%;\n}\n\n.summary-metadata {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem 1.2rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  overflow-wrap: anywhere;\n}\n\n.summary-metadata span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.summary-metadata strong {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 600;\n}\n\n.configuration-card,\n.create-option-card {\n  padding: 1.35rem 1.4rem;\n  background: var(--ca-surface, #fff);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.section-heading,\n.create-option-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  margin-bottom: 1.3rem;\n}\n\n.section-heading-icon {\n  display: inline-flex;\n  flex: 0 0 38px;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  color: var(--ca-primary, #0e2e80);\n  background: #edf3ff;\n  border-radius: 10px;\n  font-size: 1.05rem;\n}\n\n.section-heading h2,\n.create-option-header h2 {\n  margin: 0 0 0.25rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.98rem;\n  font-weight: 700;\n}\n\n.section-heading p,\n.create-option-header p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.79rem;\n}\n\n.optional-note {\n  margin-left: auto;\n  padding: 0.32rem 0.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  background: var(--ca-bg-secondary, #eef2f8);\n  border-radius: 5px;\n  font-size: 0.63rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  white-space: nowrap;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.2rem 1.35rem;\n}\n\n.field-group {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.field-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.field-label-row .form-label {\n  margin-bottom: 0;\n}\n\n.form-label {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.81rem;\n  font-weight: 600;\n}\n\n.form-control,\n.form-select {\n  width: 100%;\n  min-height: 42px;\n  padding: 0.62rem 0.75rem;\n  background-color: var(--ca-input-bg, #fff);\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n}\n\n.form-control::placeholder {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);\n}\n\n.field-hint {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.71rem;\n}\n\n.select-with-status {\n  position: relative;\n}\n\n.select-with-status .form-select {\n  padding-right: 2.4rem;\n}\n\n.field-spinner {\n  position: absolute;\n  top: 50%;\n  right: 2rem;\n  color: var(--ca-primary, #0e2e80);\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.add-option-button,\n.text-action {\n  padding: 0;\n  border: 0;\n  color: var(--ca-primary, #0e2e80);\n  background: transparent;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.add-option-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n}\n\n.add-option-button:hover,\n.text-action:hover {\n  color: var(--ca-primary-dark, #0d2863);\n  text-decoration: underline;\n}\n\n.field-error {\n  color: #b42332;\n  font-size: 0.72rem;\n  line-height: 1.4;\n}\n\n.create-option-card {\n  margin-top: 1rem;\n  border-color: #cbd8f4;\n  background: #fbfcff;\n}\n\n.create-option-header {\n  align-items: center;\n  margin-bottom: 0.9rem;\n}\n\n.small-icon {\n  flex-basis: 32px;\n  width: 32px;\n  height: 32px;\n  font-size: 0.9rem;\n}\n\n.icon-close-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin-left: auto;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 7px;\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.create-option-controls {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.75rem;\n}\n\n.create-option-submit {\n  flex-shrink: 0;\n  min-height: 42px;\n}\n\n.create-option-error {\n  display: block;\n  margin: 0.65rem 0 0;\n}\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding: 1rem 0 0.5rem;\n}\n\n.action-note {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.74rem;\n}\n\n.action-note i {\n  color: var(--ca-primary, #0e2e80);\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.65rem;\n}\n\n.action-buttons .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.save-button {\n  min-width: 185px;\n}\n\n@media (max-width: 767.98px) {\n  .configure-page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .back-button {\n    align-self: flex-start;\n  }\n\n  .asset-summary-card,\n  .configuration-card,\n  .create-option-card {\n    padding: 1rem;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .optional-note {\n    display: none;\n  }\n\n  .form-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .action-buttons {\n    width: 100%;\n  }\n\n  .action-buttons .btn {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .asset-summary-card {\n    gap: 0.65rem;\n    padding: 0.85rem;\n  }\n\n  .summary-leading-icon {\n    flex-basis: 38px;\n    width: 38px;\n    height: 38px;\n  }\n\n  .summary-metadata {\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n\n  .create-option-controls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .create-option-submit {\n    width: 100%;\n  }\n\n  .save-button {\n    min-width: 0;\n  }\n}\n\n\n/* Breadcrumb used by the shared workflow navigation template. */\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n  margin: 1.5rem 0 1rem 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  cursor: pointer;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.breadcrumb-link:hover {\n  color: var(--ca-primary-dark, #0d2863);\n  text-decoration: underline;\n}\n\n.breadcrumb-link:focus-visible {\n  outline: 3px solid rgba(40, 80, 173, 0.25);\n  outline-offset: 3px;\n  border-radius: var(--ca-radius-sm, 6px);\n}\n\n.breadcrumb-link i,\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-divider,\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n/* Checkbox-based multi-select fields. */\n.multi-select-options {\n  display: flex;\n  min-height: 42px;\n  max-height: 210px;\n  flex-direction: column;\n  gap: 0.1rem;\n  overflow-y: auto;\n  padding: 0.35rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-input-bg, #fff);\n}\n\n.multi-select-options:focus-within {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.14);\n}\n\n.multi-select-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  margin: 0;\n  padding: 0.52rem 0.6rem;\n  border-radius: 5px;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  font-weight: 400;\n  line-height: 1.35;\n  cursor: pointer;\n}\n\n.multi-select-option:hover {\n  background: var(--ca-surface-hover, #f5f8ff);\n}\n\n.multi-select-option .form-check-input {\n  flex: 0 0 auto;\n  margin-top: 0.12rem;\n  cursor: pointer;\n}\n\n.multi-select-option .form-check-input:checked {\n  background-color: var(--ca-primary, #0e2e80);\n  border-color: var(--ca-primary, #0e2e80);\n}\n\n.multi-select-option span {\n  overflow-wrap: anywhere;\n}\n\n.multi-select-empty,\n.multi-select-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.76rem;\n}\n\n.multi-select-loading .spinner-border {\n  color: var(--ca-primary, #0e2e80);\n}\n\n@media (max-width: 480px) {\n  .breadcrumb {\n    margin-left: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
